import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';
import { PO_ITEM_COL, poCompactSelectStyles, } from '../purchaseOrder/poItemGridColumns';

const UserStoreItems = ({ onRequisitionData, itemData, selectedLocation, formData, currencyPrecision, itemtype }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const [rowsUpdated, setRowsUpdated] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);

    const [columnWidths, setItemColumnWidths] = useState({
        remove: 50,
        srNo: 80,
        itemNo: 180,
        description: 300,
        specification: 250,
        qty: 110,
        uom: 150,
        inventoryQty: 150,
        stock: 140,
        stockType: 120,
        deliveryDate: 180,
    });
    useEffect(() => {

        if (selectedLocation && selectedLocation.label && rows[0].itemNo) {
            updateRowsWithNewStock();
            setRowsUpdated(true);
        }
    }, [selectedLocation]);
    useEffect(() => {
        const getItems = async () => {
            try {
                if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
                    const formattedRowsitm = itemData?.prDetails.map(async (detail, index) => {
                        const selecteditms = await apiService.getApiParamater("GET_ITEM", `?itemDescription=${detail.itemDescription}`);
                        let selecteditem = selecteditms?.data?.result[0]

                        return {
                            requisitionNo: detail.requisitionNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            // baseQty: selecteditem.convToInvUOM * detail.qty,
                            baseQty: 1 * detail.qty,
                            convRate: selecteditem.convToInvUOM,
                            baseAmount: detail.unitPrice,
                            specification: detail.specification,
                            amount: detail.amount,
                            stock: selecteditem.stock,
                            bol: '',
                            stockType: detail.stockType,
                            balQty: detail.balQty
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsitm);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        onRequisitionData(formattedRows);
                    }
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }
    }, [itemData, dispatch, onRequisitionData]);
    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);
    useEffect(() => {
        onRequisitionData(rows);
    }, [rows]);
    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, [itemtype]);
    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', itemtype?.value || "");
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setItemOptions(fetchedItems);
            } else {
                setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            params.append('ItemNo', itemtype?.value || "");

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setDescriptionOptions(fetchedItems);
            } else {
                setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        try {
            if (fieldName === 'qty' && value < 0) {
                toast.warning('Quantity cannot be less than 0.');
                return;
            }

            // const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
            // if (isDuplicate) {
            //     toast.error('Please choose a different item.');
            //     return;
            // }
            if (selectedLocation.length === 0) {
                toast.warning("Select Location");
                return;
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };

            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {
                const queryParam = fieldName === 'itemNo' ? `itemNo=${value}` : `ItemDescription=${value}`;
                const res = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${selectedLocation.label}&${queryParam}`);

                let selecteditmstock = res?.data?.result?.[0]
                if (selecteditmstock) {
                    updatedRow.itemDescription = selecteditmstock.itemDescription;
                    updatedRow.requisitionNo = selecteditmstock.itemDescription;
                    updatedRow.uom = selecteditmstock.unitMeasurement;
                    updatedRow.itemNo = selecteditmstock.itemNo;
                    updatedRow.specification = selecteditmstock.specification;
                    updatedRow.baseQty = 0;
                    updatedRow.stock = selecteditmstock?.stock || 0;
                    updatedRow.stockType = selecteditmstock?.stockType;
                    updatedRow.supplierId = selecteditmstock?.supplier;
                    updatedRow.baseAmount = selecteditmstock?.avgPrice;
                }
            }

            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const baseQty = 1; // Adjust this as necessary
                updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty).toFixed(currencyPrecision || 0) : 0;
            }

            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const quantity = parseFloat(updatedRow.qty);
                const unitPrice = parseFloat(updatedRow.baseAmount);
                updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(currencyPrecision || 0) : 0;
            }

            if (fieldName === 'specification') {
                updatedRow.specification = value;
            }
            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            recordId: '',
            specification: '',
            supplierId: '',
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    };
    const updateRowsWithNewStock = async () => {
        try {

            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM_STORE',
                    `?Warehouse=${selectedLocation.label}&${queryParam}`
                );
                if (response?.data?.statusCode === 200) {

                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock || 0;
                    updatedRows[index].stockType = itemData.stockType || "---";
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].uom = itemData.unitMeasurement;
                    // updatedRows[index].baseQty = parseFloat(itemData.convToInvUOM);
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows([...updatedRows]));
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    const ResizableHeader = ({ column, children }) => (
        <th
            style={{
                width: `${columnWidths[column]}px`,
                minWidth: `${columnWidths[column]}px`,
                position: "relative"
            }}
        >
            {children}

            <span
                className="resize-handle"
                onMouseDown={(e) =>
                    startItemColumnResize(e, column)
                }
            />
        </th>
    );
    const startItemColumnResize = (e, column) => {
        e.preventDefault();

        const startX = e.clientX;
        const startWidth = columnWidths[column];

        const handleMouseMove = (event) => {
            const newWidth = Math.max(
                50,
                startWidth + (event.clientX - startX)
            );

            setItemColumnWidths((prev) => ({
                ...prev,
                [column]: newWidth
            }));
        };

        const handleMouseUp = () => {
            document.removeEventListener(
                "mousemove",
                handleMouseMove
            );
            document.removeEventListener(
                "mouseup",
                handleMouseUp
            );
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className="dynoTable">
                    <tr>
                        <ResizableHeader column="remove">
                            <span></span>
                        </ResizableHeader>

                        <ResizableHeader column="srNo">
                            Sr no
                        </ResizableHeader>

                        <ResizableHeader column="itemNo">
                            Item No
                        </ResizableHeader>

                        <ResizableHeader column="description">
                            Description
                        </ResizableHeader>

                        <ResizableHeader column="specification">
                            Specification
                        </ResizableHeader>
                        <ResizableHeader column="qty">
                            Qty
                        </ResizableHeader>

                        <ResizableHeader column="uom">
                            Inventory UOM
                        </ResizableHeader>

                        <ResizableHeader column="inventoryQty">
                            Inventory Qty
                        </ResizableHeader>

                        <ResizableHeader column="stock">
                            Stock
                        </ResizableHeader>

                        <ResizableHeader column="stockType">
                            Stock Type
                        </ResizableHeader>

                        <ResizableHeader column="deliveryDate">
                            Delivery Date
                        </ResizableHeader>
                    </tr>
                </thead>

                <tbody>
                    {Array.isArray(itemRows) &&
                        rows?.map((row, index) => (
                            <tr key={index}>

                                {/* Remove */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.remove}px`,
                                        minWidth: `${columnWidths.remove}px`,
                                        border: "1px solid rgba(118, 118, 118, 0.3)",
                                    }}
                                >
                                    <div
                                        onClick={
                                            itemData?.eye
                                                ? undefined
                                                : () => handleRemoveRow(index)
                                        }
                                        className="center"
                                        style={{
                                            cursor: itemData?.eye
                                                ? "not-allowed"
                                                : "pointer",
                                        }}
                                    >
                                        <RxCross1 size={25} />
                                    </div>
                                </td>

                                {/* Sr No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.srNo}px`,
                                        minWidth: `${columnWidths.srNo}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row?.srno}
                                        disabled
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Item No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.itemNo}px`,
                                        minWidth: `${columnWidths.itemNo}px`,
                                    }}
                                >
                                    {itemData?.eye ? (
                                        <input
                                            className="p-2"
                                            type="text"
                                            disabled
                                            value={row?.itemNo}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box",
                                            }}
                                        />
                                    ) : (
                                        <AsyncSelect
                                            cacheOptions
                                            value={{
                                                value: row?.itemNo,
                                                label: row?.itemNo,
                                            }}
                                            options={itemOptions}
                                            loadOptions={loadOptions}
                                            onChange={(selectedOption) =>
                                                handleInputChange(
                                                    index,
                                                    "itemNo",
                                                    selectedOption?.label
                                                )
                                            }
                                            defaultOptions={itemOptions}
                                            onMenuScrollToBottom={loadMoreOptions}
                                            styles={{
                                                ...poCompactSelectStyles("itemNo"),
                                                container: (base) => ({
                                                    ...base,
                                                    width: "100%",
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    width: "100%",
                                                    minWidth: 0,
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue.length < 3
                                                    ? "Type at least 3 characters..."
                                                    : "No records found"
                                            }
                                        />
                                    )}
                                </td>

                                {/* Description */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.description}px`,
                                        minWidth: `${columnWidths.description}px`,
                                    }}
                                >
                                    {itemData?.eye ? (
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row?.itemDescription}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box",
                                            }}
                                        />
                                    ) : (
                                        <AsyncSelect
                                            cacheOptions
                                            value={{
                                                value: row?.itemDescription,
                                                label: row?.itemDescription,
                                            }}
                                            options={descriptionOptions}
                                            loadOptions={loadDescOptions}
                                            onChange={(selectedOption) =>
                                                handleInputChange(
                                                    index,
                                                    "itemDescription",
                                                    selectedOption?.label
                                                )
                                            }
                                            defaultOptions={descriptionOptions}
                                            onMenuScrollToBottom={loadMoreDescOptions}
                                            styles={{
                                                ...poCompactSelectStyles(
                                                    "description"
                                                ),
                                                container: (base) => ({
                                                    ...base,
                                                    width: "100%",
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    width: "100%",
                                                    minWidth: 0,
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue.length < 3
                                                    ? "Type at least 3 characters..."
                                                    : "No records found"
                                            }
                                        />
                                    )}
                                </td>

                                {/* Specification */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.specification}px`,
                                        minWidth: `${columnWidths.specification}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        onWheel={(e) => e.target.blur()}
                                        onKeyDown={preventNegativeSign}
                                        value={row?.specification}
                                        disabled={itemData?.eye}
                                        onChange={(e) =>
                                            handleInputChange(
                                                index,
                                                "specification",
                                                e.target.value
                                            )
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>
                                {/* Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.qty}px`,
                                        minWidth: `${columnWidths.qty}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        onKeyDown={preventNegativeSign}
                                        value={row?.qty}
                                        disabled={itemData?.eye}
                                        onChange={(e) =>
                                            handleInputChange(
                                                index,
                                                "qty",
                                                e.target.value
                                            )
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Inventory UOM */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.uom}px`,
                                        minWidth: `${columnWidths.uom}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        type="text"
                                        value={row?.uom}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Inventory Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.inventoryQty}px`,
                                        minWidth: `${columnWidths.inventoryQty}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        type="number"
                                        value={row?.baseQty}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Stock */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.stock}px`,
                                        minWidth: `${columnWidths.stock}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        type="text"
                                        value={row?.stock || 0}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Stock Type */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.stockType}px`,
                                        minWidth: `${columnWidths.stockType}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        type="text"
                                        value={row?.stockType || "---"}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                                {/* Delivery Date */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.deliveryDate}px`,
                                        minWidth: `${columnWidths.deliveryDate}px`,
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        type="datetime-local"
                                        value={formData?.deliveryDate}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                </td>

                            </tr>
                        ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            Add Item
                        </button>
                    </div>
                    {/* <div className=' col-2'>
                        <button className='mainbtn ' onClick={removeLastRow}>
                            Remove
                        </button>
                    </div> */}
                </div>
            }
        </div>
    );
};

export default UserStoreItems;
